import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import HeroSection from './components/HeroSection';
import AppPreviewSection from './components/AppPreviewSection';
import FeaturesSection from './components/FeaturesSection';
import WhyMetroRahiSection from './components/WhyMetroRahiSection';
import PoliciesSection from './components/PoliciesSection';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfUse from './components/TermsOfUse';
import AppPrivacyPolicy from './components/AppPrivacyPolicy';
import AppTermsOfUse from './components/AppTermsOfUse';
import AppRefundPolicy from './components/AppRefundPolicy';
import AppAccountDelete from './components/AppAccountDelete';

function HomePage() {
  // Global navigation handler for footer links
  useEffect(() => {
    const handleGlobalHashChange = () => {
      const hash = window.location.hash.substring(1); // Remove the # symbol
      
      if (hash && !['privacy', 'terms', 'refund'].includes(hash)) {
        // Handle non-policy navigation (about, features, support)
        const targetSection = document.getElementById(hash);
        if (targetSection) {
          targetSection.scrollIntoView({ behavior: 'smooth' });
        }
      }
    };

    // Check hash on component mount
    handleGlobalHashChange();

    // Listen for hash changes
    window.addEventListener('hashchange', handleGlobalHashChange);

    return () => {
      window.removeEventListener('hashchange', handleGlobalHashChange);
    };
  }, []);

  return (
    <div className="App">
      <HeroSection />
      <AppPreviewSection />
      <FeaturesSection />
      <WhyMetroRahiSection />
      {/* <TestimonialsSection /> */}
      <PoliciesSection />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy_policy" element={<PrivacyPolicy />} />
        <Route path="/terms_policy" element={<TermsOfUse />} />
        <Route path="/app/privacy_policy" element={<AppPrivacyPolicy />} />
        <Route path="/app/terms_policy" element={<AppTermsOfUse />} />
        <Route path="/app/refund_policy" element={<AppRefundPolicy />} />
        <Route path="/account_delete" element={<AppAccountDelete />} />
      </Routes>
    </Router>
  );
}

export default App;
